import { FC, HTMLAttributes } from 'react';

import { Spin } from 'antd';
import cn from 'classnames';

import styles from './OverlayLoader.module.scss';

interface IOverlayLoaderProps extends HTMLAttributes<HTMLDivElement> {
	size?: 'small' | 'default' | 'large';
}

export const OverlayLoader: FC<IOverlayLoaderProps> = ({ className, size = 'large', ...props }) => {
	return (
		<div {...props} className={cn(className, styles.overlayLoader)}>
			<Spin size={size} />
		</div>
	);
};
